import { createContext, useContext } from "react";

export const WizardCtx = createContext(null);
export const useWizard = () => useContext(WizardCtx);
